module.exports = __webpack_public_path__ + "static/img/dongying2.9d484656.jpg";